import { JastBuilder } from '@atlaskit/jql-ast';
export var isValidJql = function isValidJql(jql) {
  var _jast$errors;
  var jast = new JastBuilder().build(jql);
  return (jast === null || jast === void 0 || (_jast$errors = jast.errors) === null || _jast$errors === void 0 ? void 0 : _jast$errors.length) === 0;
};